module.exports = __webpack_public_path__ + "img/plus_btn.b2d43db6.png";